import React, { ReactNode } from 'react'
import { usePublicApiSession } from '../../public-api/hooks/usePublicApiSession'
import { OrganisationRoleEnum } from '../../graphql/public/PublicSchemaTypes'
import { HideOnMobileDevice } from './HideOnMobileDevice'

type Props = {
  children: ReactNode | Element
  allowManagerAccess?: boolean
}

export const AdminOnlyAllowed = ({
  children,
  allowManagerAccess = false
}: Props) => {
  const { session } = usePublicApiSession()

  const isAdminOrManager =
    session?.user.organisation_role === OrganisationRoleEnum.ADMIN ||
    (allowManagerAccess &&
      session?.user.organisation_role === OrganisationRoleEnum.MANAGER)

  if (isAdminOrManager) {
    return <HideOnMobileDevice>{children}</HideOnMobileDevice>
  }

  return null
}
